var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPie1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ca_rd",
    "data-name": "icon-ca rd",
    transform: "translate(0 -3397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 56,
    height: 56,
    transform: "translate(0 3397)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-chart-pie-alt",
    transform: "translate(11.41 3402.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67440",
    "data-name": "Group 67440",
    transform: "translate(0.569 6.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67439",
    "data-name": "Group 67439",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80498",
    "data-name": "Path 80498",
    d: "M25.832,61.6H19.461a2.7,2.7,0,0,1-2.7-2.7V52.5A4.056,4.056,0,0,0,15.18,49.28a3.882,3.882,0,0,0-3.354-.722A14.83,14.83,0,1,0,29.79,66.539a3.888,3.888,0,0,0-.721-3.36A4.13,4.13,0,0,0,25.832,61.6Zm1.336,4.283A12.126,12.126,0,1,1,12.487,51.185a1.178,1.178,0,0,1,1.033.233,1.374,1.374,0,0,1,.541,1.09v6.384A5.408,5.408,0,0,0,19.469,64.3h6.371a1.407,1.407,0,0,1,1.1.541,1.2,1.2,0,0,1,.224,1.038Z",
    transform: "translate(-0.569 -45.777)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80499",
    "data-name": "Path 80499",
    d: "M312.094,16.059A13.619,13.619,0,0,0,302.537,6.5a2.839,2.839,0,0,0-.735-.1,2.7,2.7,0,0,0-2.73,2.7v6.354a4.056,4.056,0,0,0,4.056,4.056h6.38a2.715,2.715,0,0,0,2.586-3.453Zm-3.377.749h-5.595a1.352,1.352,0,0,1-1.352-1.352l-.011-6.345a.065.065,0,0,1,.034-.012h.035a10.913,10.913,0,0,1,7.674,7.709Z",
    transform: "translate(-280.155 -6.398)",
    fill: "#12784a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie1);
export default __webpack_public_path__ + "static/media/pie1.9310221e1f01c02d111b66d9ae51ec2f.svg";
export { ForwardRef as ReactComponent };